/**
 * SaveableKey — the stable identity of a saveable entity across every SaveButton
 * instance (SV-C1).
 *
 * A `listing` id and an `estate` id are distinct branded types but both erase to
 * `string` at runtime, so a bare id is NOT a safe cache key — a listing and an
 * estate that happened to share an id string would collide. `savedKey` folds the
 * `kind` discriminant INTO the key, so the listing/estate namespaces can never
 * overlap. Branded so a raw string can't be passed where a SaveableKey is
 * required.
 */
import type { SaveableRef } from './save-ref';

declare const saveableKeyBrand: unique symbol;

/** `"<kind>:<id>"` — the shared-overlay identity of a saveable. */
export type SaveableKey = string & { readonly [saveableKeyBrand]: 'SaveableKey' };

/** Fold a saveable's kind + id into its overlay key. */
export function savedKey(saveable: SaveableRef): SaveableKey {
  return `${saveable.kind}:${saveable.id}` as SaveableKey;
}
